<template>
    <div class="announcementdet content_center mtb20">
        <div class="mtb20 ft12 C787878">
            <span>您现在的位置：</span>
            <span><a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a></span>
            <span class="el-icon-arrow-right"></span>
            <span>订单结算</span>
        </div>
        <div class="flex justify_content_between mb20">
            <div class="announcementdet_box">
                <div class="announcementdet_title common_title">{{noticeData.title}}</div>
                <div class="announcementdet_cont">
                    <div v-html="noticeData.content">
                    </div>
                </div>
            </div>
            <div class="announcementdet_file">
                <div class="announcementdet_filetitle common_title mb20">{{noticeData.title}}</div>
                <p>
                    <span>公告类型：</span>
                    <span>{{noticeData.typeName}}</span>
                </p>
                <p>
                    <span>发布时间：</span>
                    <span>{{noticeData.createDate}}</span>
                </p>
                <p>
                    <span>结束时间：</span>
                    <span>{{noticeData.endTime}}</span>
                </p>
                <p>
                    <span>开始时间：</span>
                    <span>{{noticeData.startTime}}</span>
                </p>
                <div class="mtb20"><hr /></div>
                <div class="announcementdet_fileinfo">
                    <p>附件信息：</p>
                    <ul>
                       <!-- <li class="mt8 cursorP" :style="{'color':theme}" @click="downloadfile(item)" v-for="(item,index) in noticeData.files" :key="index">{{item.fileName}}</li> -->
                       <li class="mt8 cursorP" :style="{'color':theme}" v-for="(item,index) in noticeData.files" :key="index">
                           <a :href="`/upload/downloadController/download?objectName=${item.objectName}`" :download="item.name">{{item.fileName}}</a>
                       </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @description: 公告接口 
 * @param {*} HomereadNotice  通过id获取接口详情
 * @param {*} ReadNotice 通过id查看后，如果是未读，则请求此接口
 * @return {*}
 * @author: txp
 */
import {HomereadNotice,ReadNotice} from '@/api/api';
import {download} from '@/utils/index';
import { mapGetters } from 'vuex'
export default {
    name:'',
    data(){
        return{
            noticeData:{}
        }
    },
      computed: {
     ...mapGetters({
        theme: 'theme'
        })
    },
    /**
     * @description:  获取公告详情  
     * @param {*}  id 如果是未读得情况下则用id请求接口获取
     * @param {*}  已读，则通过本地存储获取公告信息
     * @return {*}
     * @author: txp
     */
    created () { 
        let id = this.$route.query.id
        this.getNoticeContent(id)
    },
    methods: {
        /**
         * @description: 通过id获取公告信息
         * @param {*} params id 
         * @return {*}
         * @author: txp
         */
        getNoticeContent(params){
            // 获取公告信息
            HomereadNotice(params).then(res=>{
                if(res.code == 200){
                    this.noticeData = res.result
                }
            })
            .catch(error=>{
                this.$message.error(error)
            })
            // 阅读公告
            ReadNotice({noticeId:params}).then(res=>{
                if(res.code == 200){
                    // this.noticeData = res.result
                }
            }).catch(error=>{
                this.$message.error(error)
            })
        },
        // 文件下载
        downloadfile(files){
            download(`${files.url}?response-content-type=application/octet-stream`,files.fileName)
        },
         // 返回上一页
        goHomes(){
           window.history.back();
        },
    }
}
</script>
<style lang="scss" scoped>
    .announcementdet{
        .announcementdet_box{
            width: 820px;
            margin-right: 70px;
            .announcementdet_cont{
                font-size: 16px;
                color: #1D1D1D;
                letter-spacing: 0;
                line-height: 30px;
                .announcementdet_img{
                    text-align: center;
                    img{
                        max-width: 820px;
                    }
                }
            }
        }
        .announcementdet_file{
            padding: 20px;
            background: rgb(241, 241, 241);
            flex: 1;
            p{
                font-size: 14px;
                color: #787878;
                letter-spacing: 0;
                line-height: 34px;
            }
            .announcementdet_fileinfo{
                p{
                    font-size: 18px;
                    color: #000000;
                }
            }
        }
    }
</style>
